import api from "@/lib/api";

// Phase 13A Wave 5 — browser voice helpers. STT/TTS proxy through the backend
// (the OpenAI key never touches the client). Audio captured via MediaRecorder.

export const voiceApi = {
  status: () => api.get("/v1/voice/status").then((r) => r.data.data),
  getConfig: (params) => api.get("/v1/voice/config", { params }).then((r) => r.data.data),
  saveConfig: (body) => api.put("/v1/voice/config", body).then((r) => r.data.data),
  // STT: send a recorded blob as multipart; returns { text, language }
  transcribe: (blob, language) => {
    const form = new FormData();
    form.append("file", new File([blob], "recording.webm", { type: blob.type || "audio/webm" }));
    if (language) form.append("language", language);
    return api.post("/v1/voice/stt", form, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data.data);
  },
  // TTS: returns an object URL for an <audio> element (caller revokes it)
  speak: async (text, voice) => {
    const res = await api.post("/v1/voice/tts", { text, voice }, { responseType: "blob" });
    return URL.createObjectURL(res.data);
  },
};

const pickMime = () => {
  const types = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4", "audio/ogg"];
  if (typeof MediaRecorder === "undefined") return "audio/webm";
  return types.find((t) => MediaRecorder.isTypeSupported(t)) || "audio/webm";
};

// Tiny recorder controller used by the Copilot mic button.
export function createRecorder() {
  let recorder = null;
  let chunks = [];
  let stream = null;

  return {
    supported: () => typeof MediaRecorder !== "undefined" && !!navigator.mediaDevices?.getUserMedia,
    async start() {
      stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mimeType = pickMime();
      recorder = new MediaRecorder(stream, { mimeType });
      chunks = [];
      recorder.ondataavailable = (e) => { if (e.data?.size > 0) chunks.push(e.data); };
      recorder.start();
    },
    stop() {
      return new Promise((resolve) => {
        if (!recorder) return resolve(null);
        recorder.onstop = () => {
          const blob = new Blob(chunks, { type: recorder.mimeType });
          stream?.getTracks().forEach((t) => t.stop());
          resolve(blob);
        };
        recorder.stop();
      });
    },
  };
}
